<template>
  <div
    class="sidebar"
    :class="isOpened ? 'open' : ''"
    :style="cssVars"
  >
    <div
      class="logo-details"
      style="margin: 6px 14px 0 14px;"
    >
      <img
        src="https://static.igem.wiki/teams/4185/wiki/logo-trans-igem.png"
        alt="menu-logo"
        class="menu-logo icon"
      >
      <div class="logo_name">
        {{ menuTitle }}
      </div>
      <i
        class="bx"
        :class="isOpened ? 'bx-menu-alt-right' : 'bx-menu'"
        id="btn"
        @click="isOpened = !isOpened"
      />
    </div>

    <div style="display: flex ; flex-direction:column; justify-content: space-between; flex-grow: 1; max-height: calc(100%); ">
      <div
        id="my-scroll"
        style="margin: 6px 14px 0 14px;"
      >
        <ul
          class="nav-list"
          style="overflow: visible;"
        >
          <li
            v-if="isSearch"
            @click="isOpened = true"
          >
            
            <span class="tooltip">{{ searchTooltip }}</span>
          </li>

          <span
            v-for="(menuItem, index) in menuItems"
            :key="index"
          >
          
            <li :id="'dropdown' + index" @click="openDropDown('dropdown' + index)" class="nav__dropdown">
              
              <a :href="menuItem.link">
                <i
                  class="bx"
                  :class="menuItem.icon "
                  />
                <span class="links_name">{{ menuItem.name }}</span>
              </a>
              <span v-for="(dropdown, indx) in menuItem.dropdowns"
                  :key="indx"
                 >
              <div class="nav__dropdown-collapse">
              <div class="nav__dropdown-content">
                 
                  <a :href="dropdown.link">
                    <i
                    class="bx"
                    :class="dropdown.icon "
                    />
                    <span class="links_name">{{ dropdown.name}}</span>
                  </a>
                
              </div>
            </div>
            </span>

              <span class="tooltip">{{ menuItem.tooltip || menuItem.name }}</span>
            </li>
          </span>
        </ul>
      </div>
      
             
      </div>
    </div>

     
</template>

<script>
  export default {
    name: 'SidebarMenuMSP',
    props: {
      //! Menu settings
      isMenuOpen: {
        type: Boolean,
        default: false,
      },
      menuTitle: {
        type: String,
        default: 'Aestuarium',
      },
      menuLogo: {
        type: String,
        
      },
      menuIcon: {
        type: String,
        default: '',
      },
      isPaddingLeft: {
        type: Boolean,
        default: true,
      },
       menuOpenedPaddingLeftBody: {
        type: String,
        default: '250px'
      },
      menuClosedPaddingLeftBody: {
        type: String,
        default: '0px'
      },

      //! Menu items
      menuItems: {
        type: Array,
        default: () => [
          {
            link: 'https://2022.igem.wiki/msp-maastricht',
            name: 'Home',
            tooltip: 'Dashboard',
            icon: 'bx-grid-alt',
          },
          
          
          {
            link: '#',
            name: 'Project',
            tooltip: 'Analytics',
            icon: 'bx-dna',
            dropdowns: [
              {
                name: 'Description',
                icon: 'bx-dna',
                link: 'https://2022.igem.wiki/msp-maastricht/description',

              },
              {
                name: 'Contribution',
                icon: 'bx-dna',
                link: 'https://2022.igem.wiki/msp-maastricht/contribution',

              },
              {
                name: 'Engineering',
                icon: 'bx-dna',
                link: 'https://2022.igem.wiki/msp-maastricht/engineering',

              },
              {
                name: 'Implementation',
                icon: 'bx-dna',
                link: 'https://2022.igem.wiki/msp-maastricht/implementation',

              },]
          },
          {
            link: '#',
            name: 'People',
            tooltip: 'User',
            icon: 'bx-user',
            dropdowns: [
              {
                name: 'Team',
                icon: 'bx-user',
                link: 'https://2022.igem.wiki/msp-maastricht/team',

              },
              {
                name: 'Attributions',
                icon: 'bx-user',
                link: 'https://2022.igem.wiki/msp-maastricht/attributions',

              },
              {
                name: 'Collaborations',
                icon: 'bx-user',
                link: 'https://2022.igem.wiki/msp-maastricht/collaborations',

              },]
          },
          {
            link: '#',
            name: 'Human Practices',
            tooltip: 'Human',
            icon: 'bx-network-chart',
            dropdowns: [

              {
                name: 'Integrated Human Practices',
                icon: 'bx-network-chart',
                link: 'https://2022.igem.wiki/msp-maastricht/human-practices',

              },
              {
                name: 'Education ',
                icon: 'bx-network-chart',
                link: 'https://2022.igem.wiki/msp-maastricht/communication',

              },]
            
            
          },
          {
            link: '#',
            name: 'Results',
            tooltip: 'Files',
            icon: 'bx-notepad',
             dropdowns: [
              {
                name: 'Proof of Concept',
                icon: 'bx-notepad',
                link: 'https://2022.igem.wiki/msp-maastricht/proof-of-concept',

              },
              {
                name: 'Model',
                icon: 'bx-notepad',
                link: 'https://2022.igem.wiki/msp-maastricht/model',

              },]
              
            
          },
          {
            link: '#',
            name: 'Awards',
            tooltip: 'Files',
            icon: 'bx-medal',
             dropdowns: [
              {
                name: 'Education',
                icon: 'bx-medal',
                link: 'https://2022.igem.wiki/msp-maastricht/education',

              },
              {
                name: 'Safety',
                icon: 'bx-medal',
                link: 'https://2022.igem.wiki/msp-maastricht/safety',

              },]
              
            
          },



          
        ],
      },

      //! Search
     
      searchTooltip: {
        type: String,
        default: 'Search',
      },

     
      //! Styles
      bgColor: {
        type: String,
        default: '#79BCD6',
      },
      secondaryColor: {
        type: String,
        default: '#01262F',
      },
      homeSectionColor: {
        type: String,
        default: '#e4e9f7',
      },
      logoTitleColor: {
        type: String,
        default: '#fff',
      },
      iconsColor: {
        type: String,
        default: '#fff',
      },
      itemsTooltipColor: {
        type: String,
        default: '#e4e9f7',
      },
      searchInputTextColor: {
        type: String,
        default: '#fff',
      },
      menuItemsHoverColor: {
        type: String,
        default: '#fff',
      },
      menuItemsTextColor: {
        type: String,
        default: '#fff',
      },
      menuFooterTextColor: {
        type: String,
        default: '#fff',
      },
    },
    data() {
      return {
        isOpened: false
      }
    },
    mounted() {
      this.isOpened = this.isMenuOpen
    },
    methods: {
      openDropDown (id) {
        let dropdown = document.getElementById(id)

        if (!dropdown.style.maxHeight) {
          document.getElementById(id).style.maxHeight = '100rem'
        } else {
          document.getElementById(id).style.maxHeight = null
        }
      }
    },
    computed: {
      cssVars() {
        return {
          '--bg-color': this.bgColor,
          '--secondary-color': this.secondaryColor,
          '--home-section-color': this.homeSectionColor,
          '--logo-title-color': this.logoTitleColor,
          '--icons-color': this.iconsColor,
          '--items-tooltip-color': this.itemsTooltipColor,
          '--serach-input-text-color': this.searchInputTextColor,
          '--menu-items-hover-color': this.menuItemsHoverColor,
          '--menu-items-text-color': this.menuItemsTextColor,
          '--menu-footer-text-color': this.menuFooterTextColor,
        }
      },
    },
    watch: {
      isOpened() {
        window.document.body.style.paddingLeft = this.isOpened && this.isPaddingLeft ? this.menuOpenedPaddingLeftBody : this.menuClosedPaddingLeftBody
      }
    }
  }
</script>